import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] text-white font-anton uppercase tracking-widest">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "Moe's Dump & Junk — Dumpster Rental & Junk Removal | Pinellas County";
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" />
      <AuthProvider>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Protected><Admin /></Protected>} />
            </Routes>
          </BrowserRouter>
        </ReactLenis>
      </AuthProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
